import { getGameName, getGameSlug } from './games';

export interface DeckSlot {
  name: string;
  min: number;
  max: number;
  query?: {
    qkey: string;
    qval: string | string[];
  };
}

export interface DeckFormat {
  maxCopies: number;
  deckSlots: DeckSlot[];
  observations?: string;
}

export interface GameRules {
  id: number;
  formats: Record<string, DeckFormat>;
}

export const RULES: Record<string, GameRules> = {
  "one-piece": {
    id: 1,
    formats: {
      "classic": {
        maxCopies: 4,
        deckSlots: [
          {
            name: "Leader",
            min: 1,
            max: 1,
            query: { qkey: "type", qval: "Leader" }
          },
          { name: "Main", min: 50, max: 50 }
        ],
        observations: "Deck é fechado em 50 + 10 dons",
      }
    } 
  },
  "digimon": {
    id: 2,
    formats: {
      "classic": {
        maxCopies: 4,
        deckSlots: [
          {
            name: "Eggs",
            min: 0,
            max: 5,
            query: { qkey: "cardType", qval: "Digi-Egg" }
          },
          { name: "Main", min: 50, max: 50 }
        ],
        observations: "5 Digitamas + 50 deck",
      }
    }
  },
  "pokemon": {
    id: 3,
    formats: {
      "standard": {
        maxCopies: 4,
        deckSlots: [
          { name: "Main", min: 60, max: 60 }
        ],
        observations: "Deck = exatamente 60 cartas (incluindo energias)",
      },
      "expanded": {
        maxCopies: 4,
        deckSlots: [
          { name: "Main", min: 60, max: 60 }
        ],
        observations: "Deck = exatamente 60 cartas (formato expandido)",
      },
      "classic": {
        maxCopies: 4,
        deckSlots: [
          { name: "Main", min: 60, max: 60 }
        ],
        observations: "Deck = 60 incluindo energias",
      }
    }  
  },
  "magic": {
    id: 4,
    formats: {
      "standard": {
        maxCopies: 4,
        deckSlots: [    
          { name: "Main", min: 60, max: 100 },
          { name: "Side", min: 0, max: 15 }
        ],
        observations: "Deck de no mínimo 60 cartas + até 15 no Sideboard"
      },
      "commander": {
        maxCopies: 1,
        deckSlots: [   
          { name: "Leader", min: 1, max: 1 }, 
          { name: "Main", min: 100, max: 100 },
          { name: "Side", min: 0, max: 15 }
        ],
        observations: "1 Comandante + 99 cartas singleton (total 100)"
      },
      "modern": {
        maxCopies: 4,
        deckSlots: [
          { name: "Main", min: 60, max: 100 },
          { name: "Side", min: 0, max: 15 }
        ],
        observations: "Modern: min 60 cartas + até 15 sideboard"
      },
      "pauper": {
        maxCopies: 4,
        deckSlots: [
          { name: "Main", min: 60, max: 100 },
          { name: "Side", min: 0, max: 15 }
        ],
        observations: "Pauper: apenas cartas comuns"
      },
      "pioneer": {
        maxCopies: 4,
        deckSlots: [
          { name: "Main", min: 60, max: 100 },
          { name: "Side", min: 0, max: 15 }
        ],
        observations: "Pioneer: min 60 cartas"
      },
      "legacy": {
        maxCopies: 4,
        deckSlots: [
          { name: "Main", min: 60, max: 100 },
          { name: "Side", min: 0, max: 15 }
        ],
        observations: "Legacy: formato eterno"
      },
      "vintage": {
        maxCopies: 4,
        deckSlots: [
          { name: "Main", min: 60, max: 100 },
          { name: "Side", min: 0, max: 15 }
        ],
        observations: "Vintage: formato irrestrito com lista de restritas"
      },
      "classic": {
        maxCopies: 4,
        deckSlots: [
          { name: "Main", min: 60, max: 100 },
          { name: "Side", min: 0, max: 15 }
        ]
      }
    }   
  },
  "gundam": {
    id: 5,
    formats: {
      "classic": {
        maxCopies: 4,
        deckSlots: [         
          { name: "Main", min: 50, max: 50 },
          { name: "Resource", min: 10, max: 10 }
        ],
        observations: "Cada “Nation” define restrições",
      }
    }  
  },
  "dragon-ball-fusion": {
    id: 6,
    formats: {
      "classic": {
        maxCopies: 4,
        deckSlots: [
          { name: "Leader", min: 1, max: 1 },
          { name: "Main", min: 50, max: 60 }
        ],
        observations: "Energia vem do próprio deck",
      }
    }   
  },
  "union-arena": {
    id: 7,
    formats: {
      "classic": {
        maxCopies: 4,
        deckSlots: [
          { name: "Main", min: 50, max: 50 }
        ],
        observations: "deck simples",
      } 
    }    
  },
  "star-wars": {
    id: 8,
    formats: {
      "Premier": {
        maxCopies: 3,
        deckSlots: [
          { name: "Leader", min: 1, max: 1 },
          { name: "Base", min: 1, max: 1 },
          { name: "Main", min: 50, max: 99 },
          { name: "Sideboard", min: 0, max: 10 }
        ],
        observations: "1 Líder + 1 Base + 50+ cartas no Main + até 10 no Sideboard"
      },
      "premier": {
        maxCopies: 3,
        deckSlots: [
          { name: "Leader", min: 1, max: 1 },
          { name: "Base", min: 1, max: 1 },
          { name: "Main", min: 50, max: 99 },
          { name: "Sideboard", min: 0, max: 10 }
        ],
        observations: "1 Líder + 1 Base + 50+ cartas no Main + até 10 no Sideboard"
      },
      "classic": {
        maxCopies: 3,
        deckSlots: [
          { name: "Leader", min: 1, max: 1 },
          { name: "Base", min: 1, max: 1 },
          { name: "Main", min: 50, max: 99 },
          { name: "Sideboard", min: 0, max: 10 }
        ],
        observations: "1 Líder + 1 Base + 50+ cartas no Main + até 10 no Sideboard"
      },
      "Twin Suns": {
        maxCopies: 1,
        deckSlots: [
          { name: "Leader", min: 2, max: 2 },
          { name: "Base", min: 1, max: 1 },
          { name: "Main", min: 50, max: 99 },
          { name: "Sideboard", min: 0, max: 10 }
        ],
        observations: "2 Líderes + 1 Base + 50+ cartas (singleton)"
      },
      "twin-suns": {
        maxCopies: 1,
        deckSlots: [
          { name: "Leader", min: 2, max: 2 },
          { name: "Base", min: 1, max: 1 },
          { name: "Main", min: 50, max: 99 },
          { name: "Sideboard", min: 0, max: 10 }
        ],
        observations: "2 Líderes + 1 Base + 50+ cartas (singleton)"
      }
    } 
  },
  "yugioh": {
    id: 9,
    formats: {
      "advanced": {
        deckSlots: [
          { name: "Main", min: 40, max: 60 },
          { name: "Extra", min: 0, max: 15 },
          { name: "Side", min: 0, max: 15 }
        ],
        maxCopies: 3,
        observations: "Formato Avançado TCG (Main: 40-60, Extra: 0-15, Side: 0-15)",
      },
      "classic": {
        deckSlots: [
          { name: "Main", min: 40, max: 60 },
          { name: "Extra", min: 0, max: 15 },
          { name: "Side", min: 0, max: 15 }
        ],
        maxCopies: 3,
        observations: "Deck Principal + Extra + Side",
      },
      "rush": {
         maxCopies: 3,
         deckSlots: [
           { name: "Main", min: 40, max: 99 },
         ],
         observations: "Regras de Rush Duel"
      },
      "speed-duel": {
        maxCopies: 3,
        deckSlots: [
          { name: "Main", min: 20, max: 30 },
          { name: "Extra", min: 0, max: 6 },
          { name: "Side", min: 0, max: 6 }
        ],
        observations: "Speed Duel (Main: 20-30, Extra: 0-6, Side: 0-6)"
      }
    }  
  },
  "cardfight-vanguard": {
    id: 10,
    formats: {
      "classic": {
        maxCopies: 4,
        deckSlots: [         
          { name: "Main", min: 50, max: 50 },
          { name: "Ride", min: 0, max: 5 },
          { name: "G", min: 0, max: 16 }
        ],
        observations: "Deck principal com 50 cartas + G-Zone (até 16 cartas) / Ride Deck",
      },
      "standard": {
        maxCopies: 4,
        deckSlots: [         
          { name: "Main", min: 50, max: 50 },
          { name: "Ride", min: 0, max: 5 },
          { name: "G", min: 0, max: 16 }
        ],
        observations: "Deck principal com 50 cartas + Ride Deck",
      },
      "premium": {
        maxCopies: 4,
        deckSlots: [         
          { name: "Main", min: 50, max: 50 },
          { name: "Ride", min: 0, max: 5 },
          { name: "G", min: 0, max: 16 }
        ],
        observations: "Deck de 50 cartas + G-Zone (até 16 cartas)",
      }
    }    
  },
  "fab": {
    id: 11,
    formats: {
      "classic": {
        deckSlots: [
          { name: "Hero", min: 1, max: 1 },
          { name: "Arena", min: 1, max: 11 },
          { name: "Main", min: 60, max: 80 }
        ],
        maxCopies: 3,
        observations: "1 Herói + Armas + Equipos"
      },
      "blitz": {
        deckSlots: [
          { name: "Hero", min: 1, max: 1 },
          { name: "Arena", min: 1, max: 11 },
          { name: "Main", min: 40, max: 52 }
        ],
        maxCopies: 2,
        observations: "1 Herói + Armas + Equipos"
      }
    }
  },
  "sorcery": {
    id: 12,
    formats: {
      "classic": {
        maxCopies: 4, // conferir regras especiais por raridade via sorceryMax
        deckSlots: [
          {
            name: "Avatar",
            min: 1,
            max: 1,
            query: { qkey: "type", qval: "Avatar" }
          },
          {
            name: "Spellbook",
            min: 60,
            max: 99,
            query: { qkey: "type", qval: ["Minion", "Magic", "Aura", "Artifact"] }
          },
          {
            name: "Atlas",
            min: 30,
            max: 99,
            query: { qkey: "type", qval: "Site" }
          },
        ],
        observations: "Deck único de 50 cartas",
      }
    } 
  },
  "riftbound": {
    id: 13,
    formats: {
      "competitive": {
        maxCopies: 3,
        deckSlots: [
          { name: "Legend", min: 1, max: 1 },
          { name: "Champion", min: 1, max: 1 },
          { name: "Main", min: 40, max: 40 },
          { name: "Battlefields", min: 3, max: 3 },
          { name: "Runes", min: 12, max: 12 },
          { name: "Sideboard", min: 0, max: 8 }
        ],
        observations: "Campeão e lenda determinam restrições do deck",
      },
      "classic": {
        maxCopies: 3,
        deckSlots: [
          { name: "Legend", min: 1, max: 1 },
          { name: "Champion", min: 1, max: 1 },
          { name: "Main", min: 40, max: 40 },
          { name: "Battlefields", min: 3, max: 3 },
          { name: "Runes", min: 12, max: 12 },
          { name: "Sideboard", min: 0, max: 8 }
        ],
        observations: "1 Lenda + 1 Campeão + 40 Deck + 3 Campos de Batalha + 12 Runas",
      }
    }
  },
  "lorcana": {
    id: 14,
    formats: {
      "core": {
        maxCopies: 4,
        deckSlots: [
          { name: "Main", min: 60, max: 99 }
        ],
        observations: "Formato Core: 60+ cartas, máximo 2 tintas/cores"
      },
      "classic": {
        maxCopies: 4,
        deckSlots: [
          { name: "Main", min: 60, max: 99 }
        ],
        observations: "60 cartas fixas, 2 cores",
      }
    }
  },
  "universus": {
    id: 15,
    formats: {
      "standard": {
        maxCopies: 4,
        deckSlots: [
          { name: "Character", min: 1, max: 1 },
          { name: "Main", min: 50, max: 99 },
          { name: "Side", min: 0, max: 10 }
        ],
        observations: "1 Character + 50+ cartas no Main + até 10 no Sideboard"
      },
      "classic": {
        maxCopies: 4,
        deckSlots: [
          { name: "Character", min: 1, max: 1 },
          { name: "Main", min: 50, max: 99 },
          { name: "Side", min: 0, max: 10 }
        ],
        observations: "1 Character + 50+ cartas no Main + até 10 no Sideboard"
      }
    }
  },
  "hololive": {
    id: 16,
    formats: {
      "standard": {
        maxCopies: 4,
        deckSlots: [
          { name: "Oshi", min: 1, max: 1 },
          { name: "Main", min: 50, max: 50 },
          { name: "Cheer", min: 20, max: 20 }
        ],
        observations: "1 Oshi holomem separado + deck principal de 50 cartas + Cheer Deck de 20 cartas."
      },
      "classic": {
        maxCopies: 4,
        deckSlots: [
          { name: "Oshi", min: 1, max: 1 },
          { name: "Main", min: 50, max: 50 },
          { name: "Cheer", min: 20, max: 20 }
        ],
        observations: "1 Oshi holomem separado + deck principal de 50 cartas + Cheer Deck de 20 cartas."
      }
    }
  },
  "altered": {
    id: 17,
    formats: {
      "constructed": {
        maxCopies: 3,
        deckSlots: [
          { name: "Hero", min: 1, max: 1, query: { qkey: "type", qval: "Hero" } },
          { name: "Main", min: 39, max: 59 }
        ],
        observations: "Deck de 40 a 60 cartas no total, incluindo exatamente 1 Hero. Todas as cartas devem ser da mesma facção do Hero. Máximo de 3 cópias por nome, 15 Rare, 3 Exalted e 3 Unique."
      },
      "classic": {
        maxCopies: 3,
        deckSlots: [
          { name: "Hero", min: 1, max: 1, query: { qkey: "type", qval: "Hero" } },
          { name: "Main", min: 39, max: 59 }
        ],
        observations: "Deck de 40 a 60 cartas no total, incluindo exatamente 1 Hero. Todas as cartas devem ser da mesma facção do Hero. Máximo de 3 cópias por nome, 15 Rare, 3 Exalted e 3 Unique."
      }
    }
  },
  "grand-archive": {
    id: 18,
    formats: {
      "standard": {
        maxCopies: 4,
        deckSlots: [
          {
            name: "Material Deck",
            min: 1,
            max: 12,
            query: { qkey: "type", qval: ["Champion", "Regalia"] }
          },
          {
            name: "Main Deck",
            min: 60,
            max: 99,
            query: { qkey: "type", qval: ["Ally", "Action", "Attack", "Item", "Weapon", "Domain", "Phantasia", "Mastery"] }
          },
          {
            name: "Sideboard",
            min: 0,
            max: 12
          }
        ],
        observations: "Material Deck (máx. 12 cartas singleton, mín. 1 Campeão Nv. 0, Custo Azul) + Main Deck (mín. 60 cartas, máx. 4 cópias, Custo Amarelo)"
      },
      "classic": {
        maxCopies: 4,
        deckSlots: [
          {
            name: "Material Deck",
            min: 1,
            max: 12,
            query: { qkey: "type", qval: ["Champion", "Regalia"] }
          },
          {
            name: "Main Deck",
            min: 60,
            max: 99,
            query: { qkey: "type", qval: ["Ally", "Action", "Attack", "Item", "Weapon", "Domain", "Phantasia", "Mastery"] }
          },
          {
            name: "Sideboard",
            min: 0,
            max: 12
          }
        ],
        observations: "Material Deck (máx. 12 cartas singleton, mín. 1 Campeão Nv. 0) + Main Deck (mín. 60 cartas)"
      }
    }
  },
  "cyberpunk": {
    id: 19,
    formats: {
      "constructed": {
        maxCopies: 3,
        deckSlots: [
          { name: "Legend", min: 3, max: 3, query: { qkey: "type", qval: "Legend" } },
          { name: "Main", min: 40, max: 50 }
        ],
        observations: "3 Legends com nomes distintos + Main Deck de 40 a 50 cartas não-Legend. Máximo de 3 cópias por combinação idêntica de nome e subtítulo. As cartas do Main devem respeitar os limites de RAM definidos pelas 3 Legends."
      },
      "classic": {
        maxCopies: 3,
        deckSlots: [
          { name: "Legend", min: 3, max: 3, query: { qkey: "type", qval: "Legend" } },
          { name: "Main", min: 40, max: 50 }
        ],
        observations: "3 Legends com nomes distintos + Main Deck de 40 a 50 cartas não-Legend. Máximo de 3 cópias por combinação idêntica de nome e subtítulo. As cartas do Main devem respeitar os limites de RAM definidos pelas 3 Legends."
      }
    }
  },
  "godzilla": {
    id: 20,
    formats: {
      "standard": {
        maxCopies: 4,
        deckSlots: [
          {
            name: "Monster",
            min: 4,
            max: 4,
            query: { qkey: "type", qval: "Monster" }
          },
          {
            name: "Main",
            min: 50,
            max: 50
          }
        ],
        observations: "Deck de Monstro (4 cartas, 1 de cada Rank I a IV) + Deck Principal (50 cartas, máx. 10 Invade 2, apenas Branco + Vermelho ou Azul)"
      },
      "classic": {
        maxCopies: 4,
        deckSlots: [
          {
            name: "Monster",
            min: 4,
            max: 4,
            query: { qkey: "type", qval: "Monster" }
          },
          {
            name: "Main",
            min: 50,
            max: 50
          }
        ],
        observations: "Deck de Monstro (4 cartas, 1 de cada Rank I a IV) + Deck Principal (50 cartas, máx. 10 Invade 2, apenas Branco + Vermelho ou Azul)"
      }
    }
  }
};

export function getRulesByGame(slug: string | number | null | undefined): GameRules | null {
  if (slug === null || slug === undefined || slug === '') return null;
  const canonical = getGameSlug(slug);
  if (canonical && RULES[canonical]) {
    return RULES[canonical];
  }
  const rawKey = String(slug).toLowerCase().trim();
  if (RULES[rawKey]) {
    return RULES[rawKey];
  }
  return null;
}

export function sorceryMax(rarity: string): number {
  switch (rarity) {
    case "Ordinary":
      return 4;
    case "Exceptional":
      return 3;
    case "Elite":
      return 2;
    case "Unique":
      return 1;
    default:
      return 4;
  } 
}

export function getSlugByGame(game: string): string {
  return getGameSlug(game);
}

export function getGameNameById(id: number | string): string {
  return getGameName(id);
}
